import { Component } from '@angular/core';

@Component({
  selector: 'app-facebook-icon',
  templateUrl: 'facebook-icon.component.svg',
  standalone: true,
})
export class FacebookIconComponent {
}

